import { render, staticRenderFns } from "./Risk.vue?vue&type=template&id=7d5269f6&scoped=true&"
import script from "./Risk.vue?vue&type=script&lang=js&"
export * from "./Risk.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d5269f6",
  null
  
)

export default component.exports